import { combineReducers } from "redux";

import counter from "../features/admin/homepage/counter/Slice";

import socialmedia from "../features/admin/homepage/socialmedia/Slice";

import banner from "../features/admin/homepage/homebanner/Slice";

import location from "../features/admin/homepage/location/Slice";

import common from "../features/admin/common/Slice";

const homepage = combineReducers({
    counter,
    socialmedia,
    banner,
    location,
    common
});

export default homepage;